module.exports = __webpack_public_path__ + "static/media/auth-cover2.ef018141.png";